import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { createContext, useContext } from 'react';
const InstanceContext = createContext({
    instanceId: -1,
    numInstances: 1
});
export const InstanceProvider = ({ children, instanceId, numInstances, isInPixiStage }) => {
    return (_jsx(InstanceContext.Provider, { value: { instanceId, numInstances }, children: isInPixiStage ? (_jsx(Container, { children: children })) : (_jsx("div", { "data-testid": `instance-${instanceId}`, style: {
                /*
                'position: relative' is required to allow dialog/modal backdrops that refer to this container to be constrained by this container's dimensions.
                See this answer and comment: https://stackoverflow.com/a/49245765
                */
                position: 'relative'
            }, children: children })) }));
};
export function useInstanceContext() {
    return useContext(InstanceContext);
}
export function useInstanceId() {
    const { instanceId } = useContext(InstanceContext);
    return instanceId;
}
export function useNumInstances() {
    const { numInstances } = useContext(InstanceContext);
    return numInstances;
}
